<template>
  <!-- 赛事分组管理页：承载男子组 / 女子组 / 混合组等通用分组配置 -->
  <div style="background:#fff; padding:20px;">
    <div style="margin-bottom:20px;">
      <a-input v-model="query.groupName" placeholder="分组名称" allow-clear style="width:200px; margin-right:10px;" />
      <a-button type="primary" icon="search" @click="handleSearch">查询</a-button>
      <a-button type="primary" icon="plus" style="margin-left:10px;" @click="handleAdd">新增分组</a-button>
    </div>

    <a-table
      :columns="columns"
      :data-source="data"
      rowKey="id"
      :loading="loading"
      :pagination="pagination"
      @change="handleTableChange"
    >
      <span slot="status" slot-scope="text">
        <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '启用' : '停用' }}</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-popconfirm title="确定删除吗？" @confirm="handleDelete(record.id)">
          <a style="color:red;">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal v-model="visible" :title="form.id ? '编辑分组' : '新增分组'" @ok="handleOk">
      <a-form-model ref="formRef" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="分组名称" prop="groupName">
          <a-input v-model="form.groupName" placeholder="如 男子组 / 女子组 / 混合组" />
        </a-form-model-item>
        <a-form-model-item label="分组编码">
          <a-input v-model="form.groupCode" placeholder="可选，如 MALE / FEMALE / MIXED" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="form.sortOrder" :min="0" style="width:100%;" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="form.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">停用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="说明">
          <a-textarea v-model="form.description" :rows="3" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { deleteDragonGroup, getDragonGroupList, saveDragonGroup } from '@/api'

export default {
  data() {
    return {
      query: { groupName: '' },
      data: [],
      loading: false,
      visible: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true
      },
      form: {
        status: 1,
        sortOrder: 0
      },
      rules: {
        groupName: [{ required: true, message: '请输入分组名称' }]
      },
      columns: [
        { title: '分组名称', dataIndex: 'groupName' },
        { title: '分组编码', dataIndex: 'groupCode' },
        { title: '排序', dataIndex: 'sortOrder', width: 90 },
        { title: '状态', dataIndex: 'status', width: 100, scopedSlots: { customRender: 'status' } },
        { title: '说明', dataIndex: 'description', ellipsis: true },
        { title: '操作', key: 'action', width: 160, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        groupName: this.query.groupName
      }
      getDragonGroupList(params).then(res => {
        this.data = (res.data && res.data.list) || []
        this.pagination.total = (res.data && res.data.total) || 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    handleAdd() {
      this.form = { status: 1, sortOrder: 0 }
      this.visible = true
    },
    handleEdit(record) {
      this.form = { ...record }
      this.visible = true
    },
    handleOk() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        saveDragonGroup(this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.loadData()
        })
      })
    },
    handleDelete(id) {
      deleteDragonGroup({ id }).then(() => {
        this.$message.success('删除成功')
        this.loadData()
      })
    }
  }
}
</script>
